const accountRouter = [
    {
        path:'',
        name:'account-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/account/index.vue'),
        children:[
            {
                path:'',
                name:'account-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視帳號 或 點選新增帳號' }
            },
            {
                path:'create',
                name:'account-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/account/create.vue')
            },
            {
                path:'detail/:id',
                name:'account-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/account/detail.vue')
            },
            {
                path:'edit/:id',
                name:'account-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/account/edit.vue')
            },
            {
                path:'changePassword/:id',
                name:'account-changePassword',
                component: () => import(/* webpackChunkName: "about" */ '../views/account/changePassword.vue')
            },
        ]
    },
  ]
  export default accountRouter

  